export default __webpack_public_path__ + "static/colors-in-italian-2819d-654bc3e9b234a80ca07b685f4a8ec07b.jpg";